import styled from 'styled-components';

import {
  cardTextStyles1,
  cardTextStyles2,
  cardStyles,
  getScheduleTime,
  getScheduleAvailability,
} from '@vimeo/live-player-cards';

const UpcomingEvents = ({ schedule, isShowing }) => {
  const style = cardStyles({ isShowing });

  return (
    <UpcomingEventsContainer style={{ ...style, bottom: '8.5%' }}>
      <div style={cardTextStyles1}>{getScheduleAvailability(schedule)}</div>
      <div style={cardTextStyles2}>{getScheduleTime(schedule)}</div>
    </UpcomingEventsContainer>
  );
};

const UpcomingEventsContainer = styled.div`
  font-family: Arial, system-ui, sans-serif;
  z-index: 1;
`;

export default UpcomingEvents;
